"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserInfoContext = void 0;
var react_1 = require("react");
var UserInfoContext_1 = require("../contexts/UserInfoContext");
//This custom hook is responsible for consuming the UserInfoContext.
function useUserInfoContext() {
    var context = (0, react_1.useContext)(UserInfoContext_1.UserInfoContext);
    if (!context) {
        throw new Error('The useUserInfoContext must be used within an UserInfoProvider.');
    }
    return context;
}
exports.useUserInfoContext = useUserInfoContext;
//# sourceMappingURL=useUserInfoContext.js.map